// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Terrain3DButton_buttonWrapper__3_mMS","terrainIcon":"Terrain3DButton_terrainIcon__3HS6e","active":"Terrain3DButton_active__24LYn"};